function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.916 0a7.916 7.916 0 107.916 7.916A7.916 7.916 0 007.916 0M1.131 7.916a6.765 6.765 0 011.6-4.382l1.955 1.954a.43.43 0 00.06.053 3.957 3.957 0 000 4.75l-.06.05-1.955 1.957a6.767 6.767 0 01-1.6-4.382m4.357 3.229a.587.587 0 00.053-.063 3.957 3.957 0 004.75 0 .729.729 0 00.053.063l1.954 1.95a6.781 6.781 0 01-8.764 0zm7.609 1.153a6.788 6.788 0 000-8.764l-1.954 1.954a.436.436 0 01-.061.053 3.957 3.957 0 010 4.75l.061.05zm-2.806-7.549a.494.494 0 01.053-.06l1.954-1.954a6.788 6.788 0 00-8.764 0l1.954 1.954a.423.423 0 01.053.06 3.961 3.961 0 014.75 0m-5.2 3.167a2.827 2.827 0 112.827 2.827 2.827 2.827 0 01-2.827-2.827",
  fillRule: "evenodd"
});

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.832 15.832",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgHelp;